<div
  *ngIf="imageUrl && hasImage"
  [class.px-3]="!isLifestyle"
  class="banner-image d-flex align-items-center overflow-hidden"
>
  <shrd-uic-image
    [containerClass]="isLifestyle ? 'image-container-cover' : 'mx-5 mx-md-0 px-6 px-md-3 pt-3 pt-md-0 pb-2 pb-md-0'"
    [src]="imageUrl"
    [alt]="imageAlt"
    [usePlaceholder]="true"
    class="position-relative image"
  ></shrd-uic-image>
</div>
<div class="banner-button-group pe-3">
  <button
    variant="tertiaryMinorBorderless"
    shrdUicButton
    class="message-close-btn btn-close"
    (click)="closeButtonClick.emit()"
  >
    <shrd-uic-svg-icon [inheritColor]="true" icon="cross" [attr.title]="closeButtonLabel"></shrd-uic-svg-icon>
  </button>
</div>
<div class="banner-content w-100 d-flex flex-column py-1 px-3">
  <span class="heading-md text-uppercase text-primary mb-0 banner-headline-text text-break">
    <span class="headline">{{ headline }}</span>
  </span>
  <div *ngIf="subHeadline">
    <p class="text-secondary text-bold banner-headline-text mb-0 sub-headline text-break">
      {{ subHeadline }}
    </p>
  </div>
  <div class="cta-button-group">
    <a
      *ngFor="let button of buttons"
      shrdUicButton
      variant="primary"
      [href]="button.uri"
      [attr.target]="button.openInNewTab ? '_blank' : null"
      (click)="ctaButtonClick.emit({ event: $event, data: button })"
    >
      <span>{{ button.label }}</span>
    </a>
  </div>
</div>
<button
  variant="tertiaryMinorBorderless"
  shrdUicButton
  class="not-show-again-btn my-0"
  (click)="dontShowAgainButtonClick.emit()"
>
  <shrd-uic-svg-icon [inheritColor]="true" icon="arrow-right"></shrd-uic-svg-icon>
  <span>{{ dontShowAgainButtonLabel }}</span>
</button>
